import React from 'react';
import ProgressBar from './ProgressBar';

const SearchTourButton = ({ onSearch }) => {
  return (
    <div className="search-widget search" style={{ background: 'transparent' }}>
      <button className="search-button" onClick={onSearch}>
        Найти
      </button>
    </div>
  );
};

export default SearchTourButton;
